// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3iA6t","content":"LoadingAlert_content__YAR19"};